import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import { ProductAccessoriesModel, getProductAccessories } from "@NA/Services/ProductAccessoriesService";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<any, ProductAccessoriesModel>;

export const DispatchCompleteLoadProductAccessories: HandlerType = props => {
    props.dispatch({
        type: "Cart/DispatchCompleteLoadProductAccessories",
        productAccessories: [],
    });
};

export const chain = [DispatchCompleteLoadProductAccessories];

const ClearProductCartAccessories = createHandlerChainRunner(chain, "ClearProductCartAccessories");
export default ClearProductCartAccessories;
